import { takeLatest, delay } from 'redux-saga'
import { put, select, call } from 'redux-saga/effects'

import actionTypes from 'redux/actions/actionTypes'
import { questionSync } from 'sync'
import callAny from '../helpers/call_any'
import { creationToolOeqActions } from 'redux/actions/creationTool'
import {
	creationToolOeqSelector,
	creationToolOeqPendingRequestsSelector,
	creationToolOeqSaveValidSelector,
} from 'redux/selectors/creationTool'
import formatError from '../helpers/error_formatter'
import { NearpodError } from 'redux/sagas/helpers/error_formatter'
import localErrorCodes from 'helpers/enums/errors/localErrorCodes'
import { localize } from 'helpers/translator'

function *oeqCreateInitialize(action) {
	if (!action.activityUid) {
		return
	}
	try {
		const activityData = yield callAny(
			questionSync.get,
			action.activityUid,
			action.jwt,
		)

		yield put(creationToolOeqActions.initializeOEQSuccess(
			activityData.payload
		))
	} catch (error) {
		const serverError = formatError(error)
		yield put(creationToolOeqActions.initializeOEQError(serverError))
	}
}

function *oeqCreateUpdateQuestion(action) {
	try {
		const oeq = yield select(creationToolOeqSelector)
		const question = {
			text: oeq.question.text,
		}

		yield callAny(
			questionSync.update,
			oeq.activityUid,
			question,
			action.jwt,
		)
		yield put(creationToolOeqActions.questionUpdateSuccess())
	} catch (error) {
		const serverError = formatError(error)
		yield put(creationToolOeqActions.questionUpdateError(serverError))
	}
}

function *oeqSave() {
	const isValidToSave = yield select(creationToolOeqSaveValidSelector)
	if (isValidToSave) {
		let hasPendingRequests = true
		while (hasPendingRequests) {
			hasPendingRequests = yield select(creationToolOeqPendingRequestsSelector)

			if (hasPendingRequests) {
				yield call(delay, 500)
			}
		}
	} else {
		throw new NearpodError(
			localErrorCodes.GENERIC_ERROR,
			localize('global_complete_fields')
		)
	}
}

function *getOeqActivity(activityUid, jwt) {
	try {
		const activityData = yield callAny(
			questionSync.get,
			activityUid,
			jwt,
		)

		yield put(
			creationToolOeqActions.getQuestionSuccess(
				activityData.payload
			)
		)
	} catch (error) {
		const serverError = formatError(error)
		yield put(
			creationToolOeqActions.getQuestionError(
				serverError
			)
		)
	}
}

export default [
	takeLatest([
		actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_INITIALIZE,
		actionTypes.VIDEO_CREATION_OEQ_INITIALIZE,
		actionTypes.VIDEO_STANDALONE_OEQ_INITIALIZE,
	], oeqCreateInitialize),
	takeLatest([
		actionTypes.CREATION_TOOL_OEQ_QUESTION_AUTOSAVE,
	], oeqCreateUpdateQuestion),
]

export {
	oeqCreateInitialize,
	oeqSave,
	getOeqActivity,
}
